import React from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { colors, fontSize } from "style";
import { withIcon, ICON_SIZE, ICON_TYPE } from "components/Icon";

const BaseLink = styled.a`
  font-size: ${fontSize.small};
  font-weight: 600;
  background: none;
  color: ${colors.purpleRainBase};
  cursor: pointer;
  transition: all 0.2s;
  text-decoration: none;
  display: inline-flex;
  align-items: center;

  &:hover:not(:disabled) {
    color: ${colors.purpleRainDark1};
  }
`;

const EditLink = ({ icon = ICON_TYPE.plus, iconSize = ICON_SIZE.large, ...props }) => {
  const Component = withIcon(BaseLink, {
    type: icon,
    size: iconSize,
    color: "inherit",
  });

  return <Component {...props} />;
};

EditLink.propTypes = {
  icon: PropTypes.string,
  iconSize: PropTypes.oneOf(Object.values(ICON_SIZE)),
};

export default EditLink;
